import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
const Context = React.createContext(undefined);
Context.displayName = 'GridSystemContext';
export function GridSystemProvider({ children, gridSystem, }) {
    return _jsx(Context.Provider, { value: { gridSystem }, children: children });
}
export function useGridSystemProvider() {
    const context = React.useContext(Context);
    const { gridSystem } = context !== null && context !== void 0 ? context : {};
    return gridSystem || 'article-grid';
}
